import styled from 'styled-components';

export const PeriodTypesContainer = styled.div`
  width: 100%;
  .period-types {
    width: 100px;
  }
  .currency-price {
    min-width: 64px;
  }

  @media screen and (max-width: 1080px) {
    width: 50%;
    align-self: flex-end;
  }
`;
